var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',_vm._g({ref:"container",staticClass:"svg-container"},_vm.$listeners),[(_vm.name)?_c('svg',{staticClass:"svg-icon",class:{noStroke: _vm.noStroke},attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"href":`#znzs-icon-${_vm.name}`}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }